import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as cm_action from 'actions/commons';
import * as booking_action from 'actions/booking';
import cm from 'helpers/commons';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul'); // 서버시간과 다를경우를 대비하여 설정함
import { DatePickerController } from 'components/Commons';
import { BookingCouponSel, BookingForm, BookingDateResult, BookingTimeResult } from 'components/BookingStatus';
import storage from 'helpers/storage';

class BookingStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: moment().startOf('day'),
      page: 1,
      pageRow: 15
    };
  }

  componentDidMount() {
    cm.mainTitle('예약 현황');

    let comInfo = (storage.get('company') || {}).info;
    if (!(comInfo || {}).isBooking) {
      this.context.router.history.push('/service/landing');
      return <div></div>;
    }
    //가맹점 목록
    this.storeSearch();

    // 식사일 기준 목록 조회
    this.bookingDateSel();
    // 결제시간 기준 조회
    this.bookingTimeSel();
  }

  //가맹점
  storeSearch = async () => {
    try {
      const { cmAPI } = this.props;
      const params = {
        filter: 'BOOKING'
      };

      await cmAPI.storeList(params);
    } catch (e) {
      console.log('##### storeSearch : ', e);
    }
  };

  // 식사일 기준 목록
  bookingDateSel = () => {
    const { bookingAPI, store } = this.props;
    const { date } = this.state;
    const params = {
      date: date.format('YYYY-MM-DD'),
      storeId: store ? store.value : null
    };

    bookingAPI.bookingDateSel(params);

    const { cmAPI } = this.props;

    cmAPI.changeExcel({
      excel: {
        date: params.date,
        storeid: params.storeId
      }
    });
  };

  // 결제시간 기준 목록
  bookingTimeSel = () => {
    const { bookingAPI, store } = this.props;
    const { date, page, pageRow } = this.state;
    const params = {
      date: date.format('YYYY-MM-DD'),
      storeId: store ? store.value : null,
      page,
      pageRow
    };

    bookingAPI.bookingTimeSel(params);
  };

  // 날짜 변경
  onChangeDate = async (date) => {
    await this.setState({ date });

    this.bookingDateSel();
    this.bookingTimeSel();
  };

  // 제휴식당 변경
  submitForm = () => {
    this.bookingDateSel();
    this.bookingTimeSel();
  };

  // 날짜 선택
  onSelectDate = async (e) => {
    const { name } = e.currentTarget;
    const { date } = this.state;
    let nDate = null;

    if (name === 'PREV') {
      nDate = date.subtract(1, 'days').startOf('day');
    } else {
      nDate = date.subtract(-1, 'days').startOf('day');
    }

    await this.setState({
      date: nDate
    });

    this.bookingDateSel();
    this.bookingTimeSel();
  };

  // 페이징
  onPageClick = async (page) => {
    await this.setState({ page });
    this.bookingTimeSel();
  };

  render() {
    const { date } = this.state;
    const { dateSel, timeSel } = this.props;
    let bookingDateList = null;
    let bookingTimeList = null;

    if (dateSel && dateSel.data) {
      const { contents } = dateSel.data;

      bookingDateList = contents;
    }

    if (timeSel && timeSel.data) {
      const { data } = timeSel;

      bookingTimeList = data;
    }

    return (
      <Fragment>
        <BookingForm onSubmit={this.submitForm} />
        <BookingCouponSel>
          <DatePickerController
            date={date}
            text={{ prev: '이전날', next: '다음날' }}
            onChange={this.onChangeDate}
            onSelect={this.onSelectDate}
          />
          <BookingDateResult contents={bookingDateList} changeStore={this.onChangeStore} />
        </BookingCouponSel>

        <BookingTimeResult data={bookingTimeList} pageClick={this.onPageClick} />
      </Fragment>
    );
  }
}

BookingStatus.contextTypes = {
  router: PropTypes.object.isRequired
};

BookingStatus = connect(
  (state) => ({
    dateSel: state.booking.bookingDateSel,
    timeSel: state.booking.bookingTimeSel,
    store: state.commons.store
  }),
  (dispatch) => ({
    bookingAPI: bindActionCreators(
      {
        bookingDateSel: booking_action.BookingDateSel,
        bookingTimeSel: booking_action.BookingTimeSel,
        bookingStoreSel: booking_action.BookingStoreSel
      },
      dispatch
    ),
    cmAPI: bindActionCreators(
      {
        storeList: cm_action.StoreList,
        changeExcel: cm_action.ChangeExcel
      },
      dispatch
    )
  })
)(BookingStatus);

export default BookingStatus;
